function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import { setCssVars, setStyle } from '../../utils/domUtils';

function wixBgMediaWrapper(WixElement, windowResizeService, services) {
  var stylesToClear = {
    width: undefined,
    height: undefined,
    left: undefined
  };

  var WixBgMedia =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(WixBgMedia, _WixElement);

    function WixBgMedia() {
      // eslint-disable-line no-useless-constructor
      return _WixElement.call(this) || this;
    }

    var _proto = WixBgMedia.prototype;

    _proto.reLayout = function reLayout() {
      var _this = this;

      var _this$dataset = this.dataset,
          containerId = _this$dataset.containerId,
          pageId = _this$dataset.pageId,
          useCssVars = _this$dataset.useCssVars;
      var container = document.getElementById("" + containerId);
      var page = document.getElementById("" + pageId);
      var isFixedStyle = window.getComputedStyle(this).position === 'fixed';
      var measures = {};
      services.mutationService.measure(function () {
        var screenHeight = document.documentElement.clientHeight;
        var containerRect = container.getBoundingClientRect();
        var pageRect = page.getBoundingClientRect();
        var width = containerRect.width + "px";
        var height = Math.max(containerRect.height, screenHeight) + "px";
        var left = isFixedStyle ? containerRect.left - pageRect.left + "px" : 0;
        var dimensions = !useCssVars ? {
          width: width,
          height: height,
          left: left
        } : {
          '--containerW': width,
          '--containerH': height,
          '--containerL': left,
          '--screenH_val': "" + screenHeight
        };
        Object.assign(measures, dimensions);
      });
      services.mutationService.mutate(function () {
        if (useCssVars) {
          setStyle(_this, stylesToClear);
          setCssVars(_this, measures);
        } else {
          setStyle(_this, measures);
        }
      });
    };

    _proto.connectedCallback = function connectedCallback() {
      _WixElement.prototype.connectedCallback.call(this);

      windowResizeService.observe(this);
    };

    _proto.disconnectedCallback = function disconnectedCallback() {
      _WixElement.prototype.disconnectedCallback.call(this);

      windowResizeService.unobserve(this);
    };

    return WixBgMedia;
  }(WixElement);

  return WixBgMedia;
}

export default wixBgMediaWrapper;
//# sourceMappingURL=wixBgMedia.js.map